import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { isScreen } from 'newJs/utils';
import { QUERY_CLIENT_OPTIONS as QCO } from 'newJs/config';
import { useBreakpoints } from 'newJs/hooks';
import theme from 'newJs/config/theme';

const DataContext = React.createContext();
const queryClient = new QueryClient(QCO.get('DEFAULT'));

const Children = ({ children, provideQuery }) => {
    return provideQuery
        ? (
            <QueryClientProvider client={queryClient}>
                {children}
            </QueryClientProvider>
        ) : children;
};

Children.propTypes = {
    children: PropTypes.node.isRequired,
    provideQuery: PropTypes.bool,
};

const GlobalPropsProvider = ({ children, value, provideQuery = false }) => {
    const breakpoint = useBreakpoints();
    const memoizedValue = useMemo(
        () => {
            // console.log('isScreen:', isScreen(breakpoint.name));
            return { isScreen: isScreen(breakpoint.name), ...value };
        },
        [breakpoint, value]
    );

    return (
        <ThemeProvider theme={{ breakpoint, ...theme }}>
            <DataContext.Provider value={memoizedValue}>
                <Children provideQuery={provideQuery}>{children}</Children>
            </DataContext.Provider>
        </ThemeProvider>
    );
};

GlobalPropsProvider.propTypes = {
    children: PropTypes.node.isRequired,
    provideQuery: PropTypes.bool,
    value: PropTypes.object
};

const useGlobalProps = () => {
    const context = React.useContext(DataContext);

    if (context === undefined) {
        throw new Error('useGlobalProps must be used within GlobalPropsProvider');
    }

    return context;
};

export { GlobalPropsProvider, useGlobalProps };
